import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBook = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 0C1.34314 0 0 1.34314 0 3V13C0 14.6569 1.34314 16 3 16H16V0H3ZM13.5 3H4.5V7H13.5V3ZM0.5 13C0.5 11.6193 1.61929 10.5 3 10.5H15.5V12H3.5C2.94771 12 2.5 12.4477 2.5 13C2.5 13.5523 2.94771 14 3.5 14H15.5V15.5H3C1.61929 15.5 0.5 14.3807 0.5 13Z"
	})
});
export default SvgBook;
